import { render, staticRenderFns } from "./RelatedProductsSelect.vue?vue&type=template&id=154ddb18"
import script from "./RelatedProductsSelect.vue?vue&type=script&lang=js"
export * from "./RelatedProductsSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports